import React from "react";

function History() {
  return (
    <div>
          <div className="row banner" style={{backgroundImage:'url(./images/makreri.jpeg)',backgroundSize:'cover',backgroundPosition:'center'}}></div>
          <div class="container">
            <div class="row">
              <div class="col-md-8">
                <div style={{padding:'60px'}}>
                  {/* <h3 className="hheading">Temple History</h3> */}
                  <p className="hcontent">
                  ത്രേതായുഗത്തിൽ ബാലിവധത്തിനുശേഷം ശ്രീരാമ ലക്ഷ്മണന്മാർ സീതാന്വേഷണാർത്ഥം സഞ്ചരിക്കവേ ഇന്ന് പെരളശ്ശേരിയെന്ന് പ്രസിദ്ധമായി തീർന്ന പ്രദേശത്തെത്തിച്ചേർന്നു. പ്രകൃതി സുന്ദരവും പരിപാവനത്ത്വം നിറഞ്ഞതുമായ ആ പ്രദേശത്ത് ഭക്തജനങ്ങളുടെ നന്മയ്ക്കായും ഭഗവാന്റെ ആഗമന സ്മരണയ്ക്കായും അവിടെയൊരു ദേവപ്രതിഷ്ഠ നടത്തണമെന്ന് ഹനുമാൻ ശ്രീരാമസ്വാമിയോടപേക്ഷിച്ചു. ഭക്തദാസനായ ഭഗവാനാകട്ടെ, തന്റെ ഭക്തന്റെ അപേക്ഷ സ്വീകരിക്കുകയും പ്രതിഷ്ഠാർത്ഥം കൈലാസത്തോളം ചെന്ന് പരമേശ്വരാനുമതിയോടെ ദേവസേനാപതിയായ ശ്രീ സുബ്രഹ്മണ്യന്റെ വിഗ്രഹം കൊണ്ടു വരുവാനായി ഹനുമാനോട് കല്പിക്കുകയും ചെയ്തു. ഹനുമാൻ തിരിച്ചെത്തുമ്പോഴേക്കും പ്രതിഷ്ഠയ്ക്കനുയോജ്വമായ ഉത്തമ മുഹൂർത്തം കഴിഞ്ഞുപോകുമെന്ന് മനസ്സിലാക്കി ശ്രീരാമസ്വാമി തന്റെ കൈയ്യിലുള്ള പെരുവളയൂരി ശ്രീ സുബ്രഹ്മണ്യ സങ്കല്പം ചെയ്ത് യഥാവിധി പ്രതിഷ്ഠിച്ചു. ശ്രീരാമന്റെ പെരുവള പ്രതിഷ്ഠിക്കപ്പെട്ട ദേശമാകയാൽ 'പെരുവളശ്ശേരി' യെന്നും, ക്രമേണ 'പെരളശ്ശേരി'യെന്നും ആ ദേശം പ്രസിദ്ധമായി. ശ്രീരാമൻ പ്രതിഷ്ഠ കഴിച്ച് അല്പനേരത്തിനുള്ളിൽ സുബ്രഹ്മണ്യ വിഗ്രഹവുമായി ഹനുമാൻ മനോവേഗത്തിൽ പറന്നെത്തി. താനെത്തുമ്പോഴേക്കും പ്രതിഷ്ഠ കഴിഞ്ഞത് കണ്ട് പശ്ചാത്താപഭരിതനായിത്തീർന്ന ഹനുമാനെ സമാശ്വസിപ്പിക്കാനായി താൻ കൊണ്ടുവന്ന സ്കന്ദവിഗ്രഹത്തെ അല്പം വടക്കുമാറി പ്രതിഷ്ഠിക്കാൻ ഹനുമാനോട് ശ്രീരാമൻ നിർദ്ദേശിച്ചു. ഇപ്രകാരം ശ്രീരാമ ലക്ഷ്മണന്മാരുടെ മഹനീയ സാന്നിദ്ധ്യത്തിൽ സാക്ഷാൽ ഹനുമാനാൽ പ്രതിഷ്ഠിക്കപ്പെട്ടതാണ് മക്രേരിയിലെ ശ്രീ സുബ്രഹ്മണ്യ പ്രതിഷ്ഠ. മർക്കട ശ്രേഷ്ഠന്മാരായ ഹനുമത്സുഗ്രീവാദികൾ താമസിച്ച ദേശം അഥവാ ചേരി എന്നർത്ഥത്തിൽ 'മർക്കടശ്ശേരി' എന്നും കാലാന്തരത്തിൽ ലോപിച്ച് 'മക്രേരി' എന്നും ഈ പ്രദേശം പ്രസിദ്ധമായി. ഇതാണ് ക്ഷേത്ര സംബന്ധമായ ഐതിഹ്യം.
                  </p>
                  
                
                </div>
                
              </div>
              <div className="col-md-4" style={{paddingTop:'60px',paddingBottom:'60px', background:' rgb(58, 0, 52'}}>
                  <img src="./images/makreri.jpeg" style={{width:'100%'}} alt="About Us" />
                </div>
              
            </div>
          </div>
    </div>
  );
}

export default History;
